<template>
  <v-card v-if="!isNone(stockage_id)">
    <v-btn
        block
        color="primary"
        v-show='!isFetching'
        @click="checkPlaces"
        >
        <div v-if='isResultFetched'>
          {{ $t("part_view.check_again") }}
        </div>
      <div v-else>
          {{ $t("part_view.check_coherence") }}
      </div>
    </v-btn>
    <div v-if="isFetching">
      <v-alert color="primary">
        <v-progress-linear
            v-if="isFetching"
            class="ml-2"
            :indeterminate="true"
            >
        </v-progress-linear>
      </v-alert>
    </div>
    <div v-if="inconsistencies.length === 0 && isResultFetched">
      <v-alert type="success">
          {{ $filters.capitalize($t("part_view.all_good")) }}
      </v-alert>

    </div>
    <div v-if="inconsistencies.length > 0 && isResultFetched">
      <v-alert type="error">
        {{ $filters.capitalize($t("part_view.found_n", {slice: inconsistencies.length})) }}
        <template v-slot:icon>
        </template>
      </v-alert>
      <v-table class="mt-2">
        <thead>
          <tr>
            <th>{{ $t("stock_parts.category") }}</th>
            <th>{{ $t("stock_parts.name")}}</th>
            <th>{{ $t("stock_parts.ref") }}</th>
            <th>{{ $t("places.label") }}</th>
            <th>{{ $t("consumables.quantity") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
              v-for="(item, index) in inconsistencies"
              :key="index"
              @click="navigateToItem(index)"
              >
              <td>{{ item.stock_part_category }}</td>
              <td>{{ item.stock_part_name }}</td>
              <td>{{ item.stock_part_ref }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.total }}</td>
          </tr>
        </tbody>
      </v-table>
    </div>
  </v-card>
</template>
<script setup>
  import { ref, watch, computed } from 'vue';
  import { useRouter } from 'vue-router';
  import { useStore } from 'vuex';
  import { isNone } from "@/functions.js";

  const props = defineProps({
    stockage_id: {
        type: Number,
        required: false,
        },
    })

  watch(
    () => props.stockage_id,
    (newValue, oldValue) => {
      reset_status();
    }
  );
  const store = useStore();
  const router = useRouter();
  const inconsistencies = ref([]);
  const isFetching = ref(false)
  const isResultFetched = ref(false);

  const reset_status = () => {
    inconsistencies.value = [];
    isFetching.value = false;
    isResultFetched.value = false;
  };
  

  const checkPlaces = async () => {
    isResultFetched.value = false;
    isFetching.value = true;
    inconsistencies.value = [];
    try {
      const response = await store.dispatch('parts/getNegativePlaces', {"stockage_id": props.stockage_id})
      inconsistencies.value = response;
      isResultFetched.value = true;
    } catch (error) {
      store.dispatch('snackbar/error', {'msg': 'oopsie'});
    } finally { 
      isFetching.value = false;
    };
  };

  const navigateToItem = (index) => {
    const item_ = inconsistencies.value[index];
    window.open(
    router.resolve({
        name: 'part_edition',
        query: {
            stockage_id: props.stockage_id,
            stock_part_id: item_.stock_part_id,
            }
        }).href, "_blank");
  };
</script>
<style scoped>
tbody tr:hover {
  background-color: #90CAF9 ;
}
</style>
